import { useTranslation } from "react-i18next";
import Button from "../../../components/ui/Button";
import Modal from "../../../components/ui/Modal";
import SegmentedControl from "../../../components/ui/SegmentedControl";
import { TermAddLineBreakMode } from "../../settings/util/termAddSettings";
import styles from "../css/TermListFilterSheet.module.css";

interface TermAddSettingSheetProps {
  open: boolean;
  onClose: () => void;
  lineBreakMode: TermAddLineBreakMode;
  onChangeLineBreakMode: (mode: TermAddLineBreakMode) => void;
  isOnDuplicatedCheck: boolean;
  onChangeDuplicatedCheck: (isOn: boolean) => void;
}

// 자주 바꾸지 않는 단어 추가 설정. 자주 쓰는 설정은 단어 추가 화면의 칩으로 바로 바꾼다.
export default function TermAddSettingSheet(props: TermAddSettingSheetProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      title={t("TermAddSettingTitle")}
      showCloseButton
      closeLabel={t("CloseButton")}
      footer={
        <Button size="lg" fullWidth onClick={props.onClose}>
          {t("CloseButton")}
        </Button>
      }
    >
      <div className={styles.sections}>
        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>
            {t("TermAddLineBreakModeTitle")}
          </h3>
          <SegmentedControl
            aria-label={t("TermAddLineBreakModeTitle")}
            value={props.lineBreakMode}
            onChange={props.onChangeLineBreakMode}
            options={[
              {
                value: TermAddLineBreakMode.lineBreak,
                label: t("TermAddLineBreakModeLineBreak"),
              },
              {
                value: TermAddLineBreakMode.nextRow,
                label: t("TermAddLineBreakModeNextRow"),
              },
            ]}
          />
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>
            {t("TermAddDuplicatedTermSettingTitle")}
          </h3>
          <SegmentedControl
            aria-label={t("TermAddDuplicatedTermSettingTitle")}
            value={props.isOnDuplicatedCheck ? "on" : "off"}
            onChange={(value) => props.onChangeDuplicatedCheck(value === "on")}
            options={[
              { value: "on", label: t("SettingOn") },
              { value: "off", label: t("SettingOff") },
            ]}
          />
        </section>
      </div>
    </Modal>
  );
}
